module.exports = __webpack_public_path__ + "img/a-ziyuan4.7de8b06d.png";